import { logEvent } from 'services/amplitude';

const logMapEvent = (): void => {
  logEvent('MapEventHandleClick');
};

export default logMapEvent;
